export default {
  data () {
    return {
      calculatedInnerHeight: undefined,
    }
  },
  mounted () {
    window.addEventListener('resize', this.calculateAvailableArea)
    this.calculateAvailableArea()
  },
  methods: {
    calculateAvailableArea () {
      const header = document.querySelector('header.v-app-bar')
      const footer = document.querySelector('footer.v-footer')
      this.calculatedInnerHeight = window.innerHeight - (header.offsetHeight + footer.offsetHeight) + 'px'
    }
  },
}